import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getIndependenceStructuredData() {
  const url = "https://restorehair.com/locations/ohio/independence/";
  const description =
    "Find out about your hair transplant options in Independence with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("independence", url, description),
    locationPageCrumbs(url, "Independence"),
  ];
}
